/**
 * @generated SignedSource<<c9b03ff98fc70d654989b990bfde2e3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ArchiveFlowInput = {
  clientMutationId?: string | null | undefined;
  flowId: UUID;
};
export type AssignmentOptionsUnarchiveMutation$variables = {
  input: ArchiveFlowInput;
};
export type AssignmentOptionsUnarchiveMutation$data = {
  readonly unArchiveFlow: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type AssignmentOptionsUnarchiveMutation = {
  response: AssignmentOptionsUnarchiveMutation$data;
  variables: AssignmentOptionsUnarchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveFlowPayload",
    "kind": "LinkedField",
    "name": "unArchiveFlow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentOptionsUnarchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentOptionsUnarchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f3cd6b278338892475c980af3f755446",
    "id": null,
    "metadata": {},
    "name": "AssignmentOptionsUnarchiveMutation",
    "operationKind": "mutation",
    "text": "mutation AssignmentOptionsUnarchiveMutation(\n  $input: ArchiveFlowInput!\n) {\n  unArchiveFlow(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "05d3f065e6f578050fc8f29ef2ae160f";

export default node;
